import ApplicationSerializer from 'lumen/serializers/application';

export default class ParityStrategySubscriptionSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(): string {
    return 'parity-strategy/subscription';
  }
}
